import camelcase from 'camelcase';

import {
  BUILDER_ROW_TYPES,
  DEFAULT_FIELD_WIDTH,
} from '../constants/campaignBuilder.js';
import { Columns } from '../constants/myCampaigns.js';
import { versionsColumnsObject } from '../constants/versionsColumnsObject.js';
import { Platform } from '../types/integrations.js';
import {
  FieldMeta,
  VersionFieldsData,
  VersionForTableView,
  VersionItem,
} from '../types/versions.js';

export const prepareMediaPlanVersionRows = ({
  versions,
  currencySign,
  platformsIntegrations,
}: {
  versions?: VersionForTableView[];
  currencySign?: string;
  platformsIntegrations: Platform[];
}) => {
  if (!versions?.length) {
    return [];
  }

  return versions.map((version) => {
    return {
      label: version.name,
      name: version.name,
      nameKey: version.name,
      subRows: prepareSubRows(
        version.items,
        platformsIntegrations,
        currencySign,
      ),
      fields: null,
      subItems: null,
      ...version.totals,
      versionId: version.id,
      isCurrentVersion: version.isCurrent,
      id: version.name,
      type: BUILDER_ROW_TYPES.VERSION,
      currencySign,
    };
  });
};

const prepareSubRows = (
  items: VersionForTableView['items'],
  platformsIntegrations: Platform[],
  currencySign?: string,
): VersionFieldsData[] => {
  return items.map((row: VersionItem) => {
    const integratedPlatform = platformsIntegrations.find(
      (platform) => platform.platform === row.name,
    );
    const logo = integratedPlatform?.logo;

    const subRows = row?.subItems
      ? prepareSubRows(
          row.subItems,
          platformsIntegrations,
          currencySign,
        ).filter((mediaPlanRow) => !!mediaPlanRow)
      : [];

    return {
      ...row,
      label: row.label,
      nameKey: row.name,
      ...row.fields,
      fields: null,
      subRows,
      subItems: null,
      currencySign,
      logo,
    };
  });
};

export const getVersionsColumnObjects = (columns?: Array<FieldMeta>) => {
  if (!columns?.length) {
    return [versionsColumnsObject[Columns.EXPANDER]];
  }
  return columns.map((col) => {
    const name = camelcase(col.name);

    const isCustomTechCost = !versionsColumnsObject[name];

    if (isCustomTechCost) {
      return {
        ...versionsColumnsObject.otherTechCost,
        id: name,
        accessor: name,
        Header: col.label,
        width: DEFAULT_FIELD_WIDTH,
      };
    }

    return {
      ...versionsColumnsObject[name],
      width: versionsColumnsObject[name]?.width || DEFAULT_FIELD_WIDTH,
      Header: col.label,
    };
  });
};
